/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import { useHistory } from "react-router-dom"
import { selectTenkoBasyoPage } from "../../../../constant/tablet/pages"
import KubunService from "../../../../service/master/kubun/kubunService"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { 区分マスタ } from "../../../../service/master/kubun/TKubun"
import { T点呼区分, e点呼区分 } from "../../../../constant/enum/unko"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"
import {
  TenkoCountContext,
  TenkoDetailContext,
  TenkoHeaderContext,
  TenkoKubunContext,
  ZyomuinContext,
} from "../../context/context"
import TenkoService from "../../../../service/truckcontrol/tenko/tenkoService"
import { TTenkoDetailInfoGetRes } from "../../../../service/truckcontrol/tenko/TTenko"

import dayjs, { Dayjs } from "dayjs"
import SpinnerInTablet from "../../../../components/SpinnerInTablet"
import TenkoTimingSelectCell from "./TenkoTimingSelectCell"

import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../../globalStore/rootreducer"
import { AppDispatch } from "../../../.."
import { setAlerts } from "../../../../globalStore/alertStore"
import TabletTenkoService from "../../../../service/tablet/tabletTenkoService"
import _ from "lodash"
import constants from "../../../../constant/constant"

const SelectTenkoTiming = () => {
  const dispatch: AppDispatch = useDispatch()
  const history = useHistory()
  const 点呼者 = useSelector((root: RootState) => root.user.LoginUserInfo)
  const { 点呼ヘッダ情報, set点呼ヘッダ情報 } = useContext(TenkoHeaderContext)
  const { 乗務員 } = useContext(ZyomuinContext)
  const { set点呼区分 } = useContext(TenkoKubunContext)
  const { set点呼明細 } = useContext(TenkoDetailContext)
  const { set点呼回数 } = useContext(TenkoCountContext)

  const [点呼区分List, set点呼区分List] = useState<区分マスタ[]>()
  const [共通指示事項List, set共通指示事項List] = useState<区分マスタ[]>([])
  const [点呼明細List, set点呼明細List] = useState<TTenkoDetailInfoGetRes[]>()
  const [点呼アラート表示点呼明細, set点呼アラート表示点呼明細] =
    useState<TTenkoDetailInfoGetRes>()

  const [isSearching, setIsSearching] = useState(false)

  const 当日dayjs = dayjs()
  const 前日dayjs = 当日dayjs.subtract(1, "d")

  const move点呼場所 =
    (
      点呼明細: TTenkoDetailInfoGetRes | undefined,
      点呼区分コード: T点呼区分,
      日付: Dayjs,
      点呼回数: number
    ) =>
    async () => {
      if (点呼ヘッダ情報?.点呼日 == null) return

      try {
        // ヘッダ情報を確認し、存在しないもしくは同一日付のヘッダではない場合再取得し設定、なければ作成する
        if (
          点呼ヘッダ情報 == null ||
          !日付.isSame(点呼ヘッダ情報.点呼日, "d")
        ) {
          // 部所内の当日の点呼情報を取得
          const 点呼情報Res = await new TenkoService().getHeader({
            点呼日: 日付.toISOString(),
            部所コード: 点呼者.部所コード,
          })

          if (点呼情報Res?.data != null) {
            const 点呼ヘッダ = 点呼情報Res?.data

            // 共通指示事項が空の場合、ランダムに入力
            if (点呼ヘッダ.共通指示事項1区分ID == null) {
              let index = Math.trunc(共通指示事項List.length * Math.random())
              index = index !== 0 ? index - 1 : 0

              const 共通指示事項1 = 共通指示事項List[index]
              点呼ヘッダ.共通指示事項1区分名称1 = 共通指示事項1.名称1
              点呼ヘッダ.共通指示事項1区分ID = 共通指示事項1.区分ID
              点呼ヘッダ.共通指示事項1区分コード = 共通指示事項1.区分コード
              点呼ヘッダ.共通指示事項1テキスト = 共通指示事項1.名称1
              点呼ヘッダ.共通指示事項2テキスト = 共通指示事項1.名称2
            }

            set点呼ヘッダ情報(点呼ヘッダ)
          } else {
            // TODO:取得できなかった場合生成する
            const res = await new TabletTenkoService().upsertTenkoHeader({
              天候区分コード: "",
              部所コード: 点呼者.部所コード,
              点呼日: 日付.toISOString(),
            })

            if (res.data) {
              set点呼ヘッダ情報(res.data)
            }
          }
        }
        set点呼回数(点呼回数)
        set点呼区分(点呼区分List?.find((e) => e.区分コード === 点呼区分コード))
        set点呼明細(点呼明細)
        history.push(selectTenkoBasyoPage.Route.path)
      } catch (error) {
        dispatch(setAlerts(error))
      }
    }

  useEffect(() => {
    setIsSearching(true)
    Promise.all([
      new KubunService().getList({
        分類コード: 区分分類コード.運行管理_勤怠.点呼区分,
      }),
      new KubunService().getList({
        分類コード: 区分分類コード.運行管理_勤怠.共通指示事項区分,
      }),
    ])
      .then(async ([点呼方法区分Res, 共通指示事項Res]) => {
        if (点呼方法区分Res && 点呼方法区分Res.data) {
          set点呼区分List(点呼方法区分Res.data)
        }
        set共通指示事項List(共通指示事項Res?.data)
      })
      .then(async () => {
        if (乗務員 == null || 点呼ヘッダ情報 == null) {
          return
        }

        const 点呼明細取得Condition = {
          社員コード: 乗務員.社員コード,
          点呼日From: 前日dayjs?.toISOString(),
          点呼日To: 当日dayjs?.toISOString(),
        }

        const 点呼明細Res = await new TenkoService().getResultList(
          点呼明細取得Condition
        )

        if (点呼明細Res && 点呼明細Res.data) {
          set点呼明細List(点呼明細Res.data)
        }
      })
      .finally(() => {
        setIsSearching(false)
      })
  }, [])

  useEffect(() => {
    if (点呼明細List == null || 点呼明細List.length <= 0) return

    // 当日のアラートを表示
    // アラート表記文字は以下の順に存在確認し表示
    // 始業 → 中間 → 終業
    let 当日アラートあり点呼明細List = 点呼明細List.filter(
      (e) =>
        dayjs(e.点呼日).isSame(当日dayjs, "D") && e.点呼アラート区分ID !== null
    )

    if (
      当日アラートあり点呼明細List.find(
        (e) => e.点呼区分コード === e点呼区分.始業点呼
      )
    ) {
      set点呼アラート表示点呼明細(
        当日アラートあり点呼明細List.find(
          (e) => e.点呼区分コード === e点呼区分.始業点呼
        )
      )
    } else if (
      当日アラートあり点呼明細List.find(
        (e) => e.点呼区分コード === e点呼区分.中間点呼１
      )
    ) {
      set点呼アラート表示点呼明細(
        当日アラートあり点呼明細List.find(
          (e) => e.点呼区分コード === e点呼区分.中間点呼１
        )
      )
    } else if (
      当日アラートあり点呼明細List.find(
        (e) => e.点呼区分コード === e点呼区分.終業点呼
      )
    ) {
      set点呼アラート表示点呼明細(
        当日アラートあり点呼明細List.find(
          (e) => e.点呼区分コード === e点呼区分.終業点呼
        )
      )
    } else {
      set点呼アラート表示点呼明細(undefined)
    }
  }, [点呼明細List])

  return (
    <>
      <SpinnerInTablet searching={isSearching}></SpinnerInTablet>
      <ZyomuinInfo>
        <div>どの時点の点呼ですか？</div>
      </ZyomuinInfo>
      <table
        style={{
          tableLayout: "fixed",
          height: CSS_PROPERTY.BODY_TABLE_HEIGHT,
          fontSize: "2rem",
        }}
        className="w-100 mt-3">
        <tbody>
          {/* サイズ調整用のtr */}
          <tr>
            <td
              style={{
                width: "10rem",
              }}></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          {[当日dayjs, 前日dayjs].map((日付, i) => {
            const 点呼最終回数 = _.max(
              (
                点呼明細List?.filter(
                  (data) =>
                    dayjs(data.点呼日).isSame(日付, "d") &&
                    data.点呼区分コード === e点呼区分.終業点呼
                ) ?? []
              ).map((e) => e?.点呼回数 ?? 0)
            )

            const 最終終業点呼 = 点呼明細List?.find(
              (data) =>
                dayjs(data.点呼日).isSame(日付, "d") &&
                data.点呼区分コード === e点呼区分.終業点呼 &&
                data.点呼回数 === 点呼最終回数
            )

            const 表示 = ["今日", "昨日"]
            const 選択用回数 =
              最終終業点呼?.点呼回数 != null
                ? 最終終業点呼?.点呼回数 < constants.登録可能最大点呼回数
                  ? 最終終業点呼?.点呼回数 + 1
                  : 最終終業点呼?.点呼回数
                : 1

            return (
              <tr key={i}>
                <td
                  style={{
                    fontSize: "2rem",
                    textAlign: "center",
                  }}>
                  {/* <div>{日付.format("YYYY年")}</div> */}
                  <div>{日付.format("MM月D日")}</div>
                  <div>({表示[i]})</div>
                </td>
                <td style={{ position: "relative" }}>
                  {/* 始業ボタン */}
                  <TenkoTimingSelectCell
                    点呼区分コード={e点呼区分.始業点呼}
                    点呼明細List={点呼明細List}
                    日付={日付}
                    点呼回数={選択用回数}
                    move点呼場所={move点呼場所}
                  />
                </td>
                <td style={{ position: "relative" }}>
                  {/* 中間ボタン */}
                  <TenkoTimingSelectCell
                    点呼区分コード={e点呼区分.中間点呼１}
                    点呼明細List={点呼明細List}
                    日付={日付}
                    点呼回数={選択用回数}
                    move点呼場所={move点呼場所}
                  />
                </td>
                <td style={{ position: "relative" }}>
                  {/* 終業ボタン */}
                  <TenkoTimingSelectCell
                    点呼区分コード={e点呼区分.終業点呼}
                    点呼明細List={点呼明細List}
                    日付={日付}
                    点呼回数={選択用回数}
                    move点呼場所={move点呼場所}
                  />
                </td>
              </tr>
            )
          })}
          <tr>
            <td
              colSpan={2}
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td colSpan={2}>
              {点呼アラート表示点呼明細 && (
                <div
                  className="text-center"
                  style={{
                    width: "calc(100% - 3rem)",
                    outline: "gray solid 2px",
                    backgroundColor: "rgb(248,248,248)",
                    fontSize: "3rem",
                    padding: "0.5rem 1rem",
                    marginBottom: "1rem",
                    color: "red",
                    fontWeight: "bold",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                  }}>
                  {点呼アラート表示点呼明細.点呼アラート区分名称1}
                </div>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SelectTenkoTiming
